import { render, staticRenderFns } from "./MaintainerDialog.vue?vue&type=template&id=5854cfd4"
import script from "./MaintainerDialog.vue?vue&type=script&lang=js"
export * from "./MaintainerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports